import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BulkTradingAccountInformation } from '../../Models/Models/Instruments/BulkTradingAccountInformation';
import { BulkTradeMode } from '../../Models/Models/Instruments/BulkTradeMode';

declare var IS_RUNNING_IN_APP_POOL;

export class InsuredFundTradingAccountClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instrumentCode: string, bulkTradeMode: BulkTradeMode): Promise<Array<BulkTradingAccountInformation>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/InsuredFundTradingAccount/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instrumentCode: instrumentCode, bulkTradeMode: bulkTradeMode }

    return AjaxWrapper.get<Array<BulkTradingAccountInformation>, any>(url, data);
  }
}

